// src/components/NotFound.js
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col } from 'react-bootstrap';
import { getLanguageFromPathname, withLanguagePrefix } from '../utils/languageRoutes';
import '../css/NotFound.css';

function NotFound() {
  const { t } = useTranslation();
  const location = useLocation();
  const language = getLanguageFromPathname(location.pathname);

  return (
    <Container className="not-found-container">
      <Row>
        <Col className="text-center">
          <h1>{t('not_found_title')}</h1>
          <p>{t('not_found_message')}</p>
          <Link to={withLanguagePrefix('/', language)} className="btn btn-primary">{t('not_found_link')}</Link>
        </Col>
      </Row>
    </Container>
  );
}

export default NotFound;
